var _polyline, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileInPlaylist({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    transform: "matrix(.0536 0 0 .0514 1.34 1.96)",
    points: "60 160 60 300 130 300",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0535 0 0 .0539 1.88 1.73)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.12,
    y: 10.9,
    width: 292,
    height: 149,
    fill: "none",
    strokeWidth: 11.8
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 65,
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 260,
    y1: 65,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 260,
    y1: 105,
    y2: 105
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.0535 0 0 .0539 8.3 12)",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 180,
    fill: "none",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 50,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 90,
    y2: 90
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    x2: 220,
    y1: 130,
    y2: 130
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInPlaylist);
export default __webpack_public_path__ + "static/media/file-in-playlist.2954a10ea78cc10c90e51ec27895c375.svg";
export { ForwardRef as ReactComponent };